@use "src/components/docs/inlineReference";

.type {
  @include inlineReference.reference;
  min-height: 0;
  border: 0;
  padding: 0.1em 0.3em;
  font-family: var(--font-mono, monospace);
  font-weight: 400;
  white-space: normal;
  overflow-wrap: anywhere;
}

.compact {
  font-size: 0.6875rem;
}
